import * as Sentry from "@sentry/react";

let initialized = false;

// AppError.meta 等、将来 extra へ生データが紛れ込んだ場合の保険（現状の呼び出し元は
// 送っていないが、SEC-04方針の「email／本文／資料内容を送らない」を多層防御する）。
const SENSITIVE_EXTRA_KEYS = new Set([
  "responseText",
  "meta",
  "accessToken",
  "refreshToken",
  "secretKey",
  "password",
  "email",
]);

export function scrubExtra(extra: Record<string, unknown>): Record<string, unknown> {
  const scrubbed: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(extra)) {
    if (SENSITIVE_EXTRA_KEYS.has(key)) continue;
    scrubbed[key] = value;
  }
  return scrubbed;
}

export function scrubEvent(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  if (event.extra) {
    event.extra = scrubExtra(event.extra);
  }
  if (event.request) {
    delete event.request.cookies;
    if (event.request.headers) {
      delete event.request.headers["Authorization"];
      delete event.request.headers["Cookie"];
    }
  }
  return event;
}

export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  if (!dsn || initialized) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_ENV ?? "production",
    release: process.env.REACT_APP_COMMIT_SHA ?? process.env.REACT_APP_VERSION,
    // XSS で盗まれた token 等が breadcrumb に載らないよう fetch/xhr のデフォルト記録を抑制
    integrations: (integrations) =>
      integrations.filter(
        (i) => i.name !== "Breadcrumbs"
      ),
    beforeSend: (event) => scrubEvent(event),
  });

  initialized = true;
}

export function isSentryInitialized(): boolean {
  return initialized;
}

export function sentrySetUser(userId: string | undefined): void {
  if (!initialized) return;
  Sentry.setUser(userId ? { id: userId } : null);
}

export function sentryCaptureException(
  error: unknown,
  extras?: Record<string, unknown>
): void {
  if (!initialized) return;
  Sentry.withScope((scope) => {
    if (extras) scope.setExtras(extras);
    Sentry.captureException(error);
  });
}

export function sentryCaptureMessage(
  message: string,
  level: "info" | "warning" | "error",
  extras?: Record<string, unknown>
): void {
  if (!initialized) return;
  Sentry.withScope((scope) => {
    if (extras) scope.setExtras(extras);
    Sentry.captureMessage(message, level);
  });
}
